  <div class="row p-2 cursor-pointer" (click)="cardClickAction.emit(ffData.product_id)">
    <div class="col-8 pr-0">
      <p class="mb-2 paragraph-bold">
          {{ffData?.title | slice:0: numbers.EIGHTY}} {{(ffData?.title.length>numbers.EIGHTY)? '...':''}}</p>
      <p class="primary-small my-2">
        <span class="clinical-compny position-relative color-grey-500">
          <img onerror="this.src='assets/themes/icons/banner-placeholder.svg'" 
            class="mr-2 post-pic rounded-circle"
            [src]="ffData.created_by.media" />
            <span class="color-grey-700">{{ffData.created_by.name}}</span> 
        </span>
      </p>
      <p class="primary-small"><span class="color-grey-500">{{ffData.views}} {{mls.languageText.clinical_resource_card.key12}}</span></p>
    </div>
  
    <div *ngIf="ffData!=''" class="col-4">
      <div class="position-relative">
        <img class="banner-img" 
          [src]="ffData?.banner" 
          onerror="this.src='assets/themes/icons/banner-placeholder.svg'" />
      </div>
    </div>
  </div>